
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8661"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8661"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("kYLQ7", function(module, exports) {

$parcel$export(module.exports, "api", () => $06004b97fba8fb24$export$644d8ea042df96a6);
const $06004b97fba8fb24$var$API_URL = 'https://gamescon-backend-559ca0f1a07e.herokuapp.com/api';
const $06004b97fba8fb24$export$644d8ea042df96a6 = {
    /**
   * Realiza o login do usuário
   */ async login (data) {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/auth/local`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        if (!response.ok) // O Strapi geralmente manda o erro detalhado em result.error.message
        throw new Error(result.error?.message || 'Erro ao fazer login.');
        return result;
    },
    /**
   * Registra um novo usuário
   */ async register (data) {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/auth/local/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
        const result = await response.json();
        /* if (!response.ok) {
      throw new Error(result.error?.message || 'Erro ao registrar usuário.');
    } */ return result;
    },
    /**
   * Gera um código de brinde para o usuário logado
   * @param jwt Token JWT recebido no login/registro
   */ async generateCode () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/codes/generate`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                // Aqui enviamos o token para o backend saber quem está pedindo o código
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) // Se ele já tiver um código, nós tratamos lá no backend pra retornar um erro ou a própria mensagem.
        // Dependendo de como você montou, pode ser que response.ok seja falso se der 400.
        throw new Error(result.error?.message || result.message || "Erro ao gerar o c\xf3digo.");
        return result;
    },
    /**
   * Pega todos os dados do usuário logado (incluindo o currentStage)
   * Ideal para chamar quando o jogo carrega!
   */ async getMe () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/users/me`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error('Erro ao carregar os dados do jogador.');
        return result; // Aqui virá { id: 1, username: "...", currentStage: 1, ... }
    },
    /**
   * Salva a fase atual do jogador
   */ async saveStage (stageNumber) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/save-progress`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                stage: stageNumber
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao salvar o jogo.');
        return result;
    },
    async getMyCodes () {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/codes/me`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${jwt}`
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error("Erro ao carregar o hist\xf3rico de c\xf3digos.");
        return result;
    },
    async sendNeozone (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/neozones`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar neozone');
        return result;
    },
    async sendOpenzone (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/ratings`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar openzone');
        return result;
    },
    async sendFinal (data) {
        const jwt = localStorage.getItem('jwt');
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/rating-finals`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
            },
            body: JSON.stringify({
                data: data
            })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || 'Erro ao enviar final');
        return result;
    },
    async isActive () {
        const response = await fetch(`${$06004b97fba8fb24$var$API_URL}/actives/smhqnmg6356byro9113fq650`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.error?.message || result.message || "Erro ao gerar o c\xf3digo.");
        return result;
    }
};

});

parcelRegister("8CkzA", function(module, exports) {

$parcel$export(module.exports, "PortalCanvas", () => $46450a05f7b89a2b$export$4e58d02b3f6ea7c);
class $46450a05f7b89a2b$export$4e58d02b3f6ea7c {
    constructor(canvas, options){
        this.w = 0;
        this.h = 0;
        this.dpr = 1;
        this.portalRadius = 80;
        this.portalCenters = [];
        this.CONFIG = {
            bgColor: '#212121',
            maxDpr: 1.15,
            portalThickness: 10,
            innerRadiusFactor: 0.9,
            ringSquares: 56,
            ringTriangles: 18,
            outerParticles: 22,
            portalImageOpacity: 0.95,
            portalImageScale: 1.06,
            portalImageDrift: 2.5,
            haloAlpha: 0.05,
            innerTintAlpha: 0.1,
            vignetteAlpha: 0.1,
            featherStart: 0.72,
            featherEnd: 1.0,
            lineAlpha: 0.08,
            pulseSpeed: 0.0018,
            spinSpeed: 0.00065,
            driftSpeed: 0.00055,
            topBottomPaddingFactor: 0.18,
            sidePaddingFactor: 0.05,
            gapFactor: 0.03
        };
        this.resize = ()=>{
            const size = Math.min(window.innerWidth * 0.8, 600); // controla aqui 👈
            this.dpr = Math.min(window.devicePixelRatio || 1, this.CONFIG.maxDpr);
            // tamanho visual (CSS via JS)
            this.canvas.style.width = `${size}px`;
            this.canvas.style.height = `${size}px`;
            // resolução real
            this.canvas.width = Math.round(size * this.dpr);
            this.canvas.height = Math.round(size * this.dpr);
            this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
            // agora o canvas "mundo" é esse tamanho
            this.w = size;
            this.h = size;
            this.portalRadius = this.getPortalRadius();
            this.buildPortalCenters();
            this.buildPortalData();
        };
        this.animate = (t)=>{
            this.drawBackground();
            for(let i = 0; i < this.portalCenters.length; i++)this.drawPortalAt(this.portalCenters[i], this.PORTALS[i], t, i);
            requestAnimationFrame(this.animate);
        };
        this.canvas = canvas;
        this.imageSrc = options.imageSrc;
        this.hue = options.hue ?? 205;
        const ctx = canvas.getContext('2d', {
            alpha: false,
            desynchronized: true
        });
        if (!ctx) throw new Error("N\xe3o foi poss\xedvel obter o contexto 2D do canvas.");
        this.ctx = ctx;
        this.PORTALS = [
            {
                imgSrc: this.imageSrc,
                hue: this.hue,
                img: new Image(),
                ringSquares: [],
                ringTriangles: [],
                particles: []
            }
        ];
    }
    init() {
        this.setupImages();
        this.resize();
        window.addEventListener('resize', this.resize, {
            passive: true
        });
        requestAnimationFrame(this.animate);
    }
    setupImages() {
        this.PORTALS.forEach((portal)=>{
            portal.img.decoding = 'async';
            portal.img.onload = ()=>{
                console.log('Imagem carregada');
                this.resize(); // força rebuild
            };
            portal.img.onerror = ()=>{
                console.error('Erro ao carregar imagem:', portal.imgSrc);
            };
            portal.img.src = portal.imgSrc;
        });
    }
    rand(min, max) {
        return Math.random() * (max - min) + min;
    }
    hsla(h, s, l, a) {
        return `hsla(${h}, ${s}%, ${l}%, ${a})`;
    }
    portalColor(hue, alpha = 1, light = 56, hueShift = 0, sat = 92) {
        return this.hsla(hue + hueShift, sat, light, alpha);
    }
    hotColor(hue, alpha = 1) {
        return this.hsla(hue - 10, 96, 68, alpha);
    }
    getPortalRadius() {
        const sidePadding = this.w * this.CONFIG.sidePaddingFactor;
        const gap = this.w * this.CONFIG.gapFactor;
        const usableWidth = this.w - sidePadding * 2 - gap * (this.PORTALS.length - 1);
        const radiusByWidth = usableWidth / (this.PORTALS.length * 2);
        const radiusByHeight = this.h * (0.5 - this.CONFIG.topBottomPaddingFactor);
        return Math.max(24, Math.min(radiusByWidth, radiusByHeight));
    }
    buildPortalCenters() {
        this.portalCenters = [];
        const gap = this.w * this.CONFIG.gapFactor;
        const diameter = this.portalRadius * 2;
        const totalWidth = this.PORTALS.length * diameter + (this.PORTALS.length - 1) * gap;
        const startX = (this.w - totalWidth) * 0.5 + this.portalRadius;
        const cy = this.h * 0.55;
        for(let i = 0; i < this.PORTALS.length; i++)this.portalCenters.push({
            x: startX + i * (diameter + gap),
            y: cy,
            phase: i * 0.9
        });
    }
    buildPortalData() {
        const r = this.portalRadius;
        const thickness = this.CONFIG.portalThickness;
        this.PORTALS.forEach((portal)=>{
            portal.ringSquares = [];
            portal.ringTriangles = [];
            portal.particles = [];
            for(let i = 0; i < this.CONFIG.ringSquares; i++){
                const a = i / this.CONFIG.ringSquares * Math.PI * 2;
                portal.ringSquares.push({
                    a: a,
                    rr: r + this.rand(-thickness, thickness),
                    size: this.rand(3, 5.5),
                    tw: this.rand(0, Math.PI * 2),
                    drift: this.rand(-1.6, 1.6)
                });
            }
            for(let i = 0; i < this.CONFIG.ringTriangles; i++){
                const a = i / this.CONFIG.ringTriangles * Math.PI * 2 + this.rand(-0.05, 0.05);
                portal.ringTriangles.push({
                    a: a,
                    rr: r + this.rand(-thickness, thickness),
                    size: this.rand(4, 6.5),
                    rot: this.rand(0, Math.PI * 2),
                    tw: this.rand(0, Math.PI * 2)
                });
            }
            for(let i = 0; i < this.CONFIG.outerParticles; i++)portal.particles.push({
                a: this.rand(0, Math.PI * 2),
                dist: r + this.rand(18, 42),
                size: this.rand(1.4, 2.8),
                speed: this.rand(0.00045, 0.0011),
                tw: this.rand(0, Math.PI * 2),
                tri: Math.random() < 0.2,
                rot: this.rand(0, Math.PI * 2)
            });
        });
    }
    drawTriangle(x, y, size, rotation, fill) {
        this.ctx.save();
        this.ctx.translate(x, y);
        this.ctx.rotate(rotation);
        this.ctx.fillStyle = fill;
        this.ctx.beginPath();
        this.ctx.moveTo(0, -size);
        this.ctx.lineTo(size * 0.82, size * 0.68);
        this.ctx.lineTo(-size * 0.82, size * 0.68);
        this.ctx.closePath();
        this.ctx.fill();
        this.ctx.restore();
    }
    drawBackground() {
        this.ctx.fillStyle = this.CONFIG.bgColor;
        this.ctx.fillRect(0, 0, this.w, this.h);
    }
    drawPortalAt(c, portal, t, index) {
        const r = this.portalRadius;
        const phase = c.phase;
        const hue = portal.hue;
        this.drawSoftHalo(c, r, t, phase, hue);
        this.drawPortalImageSoft(c, r, t, phase, hue, portal.img);
        this.drawInnerLines(c, r, t, phase, hue);
        this.drawThinRing(c, r, t, phase, hue);
        this.drawRingSquares(c, t, phase, hue, portal.ringSquares);
        this.drawRingTriangles(c, t, phase, hue, portal.ringTriangles);
        this.drawOuterParticles(c, t, phase, index, portal, portal.particles);
    }
    drawSoftHalo(c, r, t, phase, hue) {
        const pulse = 1 + Math.sin(t * this.CONFIG.pulseSpeed + phase) * 0.03;
        const g = this.ctx.createRadialGradient(c.x, c.y, r * 0.65, c.x, c.y, r * 1.45 * pulse);
        g.addColorStop(0, this.portalColor(hue, this.CONFIG.haloAlpha, 54));
        g.addColorStop(1, this.portalColor(hue, 0, 42));
        this.ctx.fillStyle = g;
        this.ctx.beginPath();
        this.ctx.arc(c.x, c.y, r * 1.5, 0, Math.PI * 2);
        this.ctx.fill();
    }
    drawPortalImageSoft(c, r, t, phase, hue, img) {
        if (!(img.complete && img.naturalWidth > 0)) return;
        const innerR = r * this.CONFIG.innerRadiusFactor;
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.arc(c.x, c.y, innerR, 0, Math.PI * 2);
        this.ctx.clip();
        const imgW = img.naturalWidth;
        const imgH = img.naturalHeight;
        const target = innerR * 2 * this.CONFIG.portalImageScale;
        const scale = Math.max(target / imgW, target / imgH);
        const drawW = imgW * scale;
        const drawH = imgH * scale;
        const driftX = Math.sin(t * this.CONFIG.driftSpeed + phase) * this.CONFIG.portalImageDrift;
        const driftY = Math.cos(t * this.CONFIG.driftSpeed * 1.2 + phase) * this.CONFIG.portalImageDrift;
        const x = c.x - drawW * 0.5 + driftX;
        const y = c.y - drawH * 0.5 + driftY;
        this.ctx.globalAlpha = this.CONFIG.portalImageOpacity;
        this.ctx.drawImage(img, x, y, drawW, drawH);
        this.ctx.restore();
    }
    drawInnerLines(c, r, t, phase, hue) {
        const rrBase = r * 0.78;
        this.ctx.save();
        this.ctx.translate(c.x, c.y);
        for(let i = 0; i < 5; i++){
            const rr = (i + 1) / 5 * rrBase;
            this.ctx.beginPath();
            this.ctx.strokeStyle = this.portalColor(hue, this.CONFIG.lineAlpha * (0.55 + i * 0.1), 68, -6);
            this.ctx.lineWidth = 1;
            for(let a = 0; a <= Math.PI * 2 + 0.06; a += 0.16){
                const wobble = Math.sin(a * 4 + t * 0.003 + i + phase) * (1 + i * 0.12);
                const rad = rr + wobble;
                const x = Math.cos(a) * rad;
                const y = Math.sin(a) * rad;
                if (a === 0) this.ctx.moveTo(x, y);
                else this.ctx.lineTo(x, y);
            }
            this.ctx.stroke();
        }
        this.ctx.restore();
    }
    drawThinRing(c, r, t, phase, hue) {
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.portalColor(hue, 0.62, 65);
        this.ctx.lineWidth = 1.5;
        this.ctx.arc(c.x, c.y, r, 0, Math.PI * 2);
        this.ctx.stroke();
        this.ctx.beginPath();
        this.ctx.strokeStyle = this.portalColor(hue, 0.2, 76);
        this.ctx.lineWidth = 1;
        this.ctx.arc(c.x, c.y, r + 3 + Math.sin(t * 0.002 + phase) * 1.1, 0, Math.PI * 2);
        this.ctx.stroke();
    }
    drawRingSquares(c, t, phase, hue, ringSquares) {
        for (const p of ringSquares){
            const tw = (Math.sin(t * 0.0035 + p.tw + phase) + 1) * 0.5;
            const rr = p.rr + Math.sin(t * 0.002 + p.tw + phase) * 1.5;
            const x = c.x + Math.cos(p.a) * rr;
            const y = c.y + Math.sin(p.a) * rr + Math.sin(t * 0.0018 + p.tw + phase) * p.drift;
            const s = p.size * (0.94 + tw * 0.22);
            this.ctx.fillStyle = this.portalColor(hue, 0.26 + tw * 0.28, 58 + tw * 12, -4);
            this.ctx.fillRect(x - s * 0.5, y - s * 0.5, s, s);
        }
    }
    drawRingTriangles(c, t, phase, hue, ringTriangles) {
        for (const p of ringTriangles){
            const tw = (Math.sin(t * 0.0037 + p.tw + phase) + 1) * 0.5;
            const rr = p.rr + Math.sin(t * 0.0022 + p.tw + phase) * 1.8;
            const x = c.x + Math.cos(p.a) * rr;
            const y = c.y + Math.sin(p.a) * rr;
            const rot = p.rot + t * this.CONFIG.spinSpeed + phase * 0.15;
            const s = p.size * (0.92 + tw * 0.2);
            this.drawTriangle(x, y, s, rot, this.hotColor(hue, 0.18 + tw * 0.2));
        }
    }
    drawOuterParticles(c, t, phase, portalIndex, portal, particles) {
        const hue = portal.hue;
        for(let i = 0; i < particles.length; i++){
            const p = particles[i];
            const a = p.a + t * p.speed + phase * 0.8 + portalIndex * 0.12;
            const x = c.x + Math.cos(a) * p.dist;
            const y = c.y + Math.sin(a) * p.dist;
            const tw = (Math.sin(t * 0.003 + p.tw + phase) + 1) * 0.5;
            const alpha = 0.08 + tw * 0.14;
            if (p.tri) this.drawTriangle(x, y, p.size, p.rot + t * 0.0008 + phase, this.portalColor(hue, alpha, 62, -8));
            else {
                this.ctx.fillStyle = this.portalColor(hue, alpha, 60, -5);
                this.ctx.fillRect(x - p.size * 0.5, y - p.size * 0.5, p.size, p.size);
            }
        }
    }
}

});

class $24dc23990372eceb$export$84cb684d9bf21001 {
    constructor({ stepSelector: stepSelector = '[data-step]', hiddenClass: hiddenClass = 'hidden', activeClass: activeClass = 'active', onFinish: onFinish, validateStep: validateStep } = {}){
        this.currentStep = 0;
        this.steps = Array.from(document.querySelectorAll(stepSelector));
        this.hiddenClass = hiddenClass;
        this.activeClass = activeClass;
        this.onFinish = onFinish;
        this.validateStep = validateStep;
    }
    init() {
        if (!this.steps.length) return;
        this.steps.forEach((step, index)=>{
            if (index === 0) {
                step.classList.remove(this.hiddenClass);
                step.classList.add(this.activeClass);
            } else {
                step.classList.remove(this.activeClass);
                step.classList.add(this.hiddenClass);
            }
        });
        this.currentStep = 0;
        this.bindButtons();
    }
    bindButtons() {
        document.querySelectorAll('[data-action="next"]').forEach((button)=>{
            button.addEventListener('click', async (e)=>{
                const btn = e.currentTarget;
                btn.disabled = true; // desabilita botão
                window.scrollTo(0, 0);
                await this.next();
                btn.disabled = false; // habilita após a api responder
            });
        });
        document.querySelectorAll('[data-action="back"]').forEach((button)=>{
            button.addEventListener('click', ()=>this.back());
        });
        document.querySelectorAll('[data-action="finish"]').forEach((button)=>{
            button.addEventListener('click', ()=>this.finish());
        });
    }
    showStep(index) {
        if (index < 0 || index >= this.steps.length) return;
        this.steps[this.currentStep].classList.remove(this.activeClass);
        this.steps[this.currentStep].classList.add(this.hiddenClass);
        this.steps[index].classList.remove(this.hiddenClass);
        this.steps[index].classList.add(this.activeClass);
        this.currentStep = index;
    }
    async next() {
        const current = this.steps[this.currentStep];
        if (this.validateStep) {
            const isValid = await this.validateStep(this.currentStep, current);
            if (!isValid) return; // Se retornou false, interrompe e não avança a página
        }
        if (this.currentStep < this.steps.length - 1) this.showStep(this.currentStep + 1);
        else this.finish();
    }
    back() {
        if (this.currentStep > 0) this.showStep(this.currentStep - 1);
    }
    finish() {
        this.onFinish?.();
    }
}


const $f0401da5f96e7704$var$PAGE_URL = {
    intro: './shadowzone.html',
    shadowzone: './neozone.html',
    neozone: './openzone.html',
    openzone: './herozone.html',
    herozone: './final.html'
};
function $f0401da5f96e7704$export$1cc5c63550d76ed8(page) {
    if (page === 'intro') return {
        stepSelector: '#stepIntroContainer, #prizes, #form, #tutorial, #zoneIntro',
        nextUrl: $f0401da5f96e7704$var$PAGE_URL[page]
    };
    if (page === 'shadowzone') return {
        stepSelector: '#stepNeoZoneContainer, #question, #zoneIntro',
        nextUrl: $f0401da5f96e7704$var$PAGE_URL[page],
        afterCodeStep: 1,
        isShortFlow: true
    };
    if (page === 'neozone') return {
        stepSelector: '#stepNeoZoneContainer, #question, #question-2, #question-3, #zoneIntro',
        nextUrl: $f0401da5f96e7704$var$PAGE_URL[page],
        afterCodeStep: 1,
        afterBranchStep: 2,
        hasBranchQuestion: true
    };
    if (page === 'openzone') return {
        stepSelector: '#stepNeoZoneContainer, #question, #question-3, #zoneIntro',
        nextUrl: $f0401da5f96e7704$var$PAGE_URL[page],
        afterCodeStep: 1
    };
    if (page === 'herozone') return {
        stepSelector: '#stepNeoZoneContainer, #zoneIntro',
        nextUrl: $f0401da5f96e7704$var$PAGE_URL[page],
        afterCodeStep: 1
    };
    if (page === 'final') return {
        stepSelector: '#experienceSurvey, #experienceCode'
    };
    return {
        stepSelector: '#stepIntroContainer, #prizes, #form, #tutorial, #zoneIntro',
        nextUrl: $f0401da5f96e7704$var$PAGE_URL.intro
    };
}


function $5f2b8dee7d819d4f$export$977dd58643642862(page) {
    return `${page}-completed`;
}
function $5f2b8dee7d819d4f$export$5a6c525e6f8d1540(page) {
    localStorage.setItem($5f2b8dee7d819d4f$export$977dd58643642862(page), 'true');
}
function $5f2b8dee7d819d4f$export$6c2447a395f7715f(page) {
    return localStorage.getItem($5f2b8dee7d819d4f$export$977dd58643642862(page)) === 'true';
}
function $5f2b8dee7d819d4f$export$dea75f1d0fc0729c(page) {
    const flow = [
        'intro',
        'shadowzone',
        'neozone',
        'openzone',
        'herozone'
    ];
    const currentIndex = flow.indexOf(page);
    if (currentIndex === -1) return;
    for(let i = 0; i < currentIndex; i++){
        const previousPage = flow[i];
        const key = $5f2b8dee7d819d4f$export$977dd58643642862(previousPage);
        if (localStorage.getItem(key) !== 'true') {
            window.location.href = './index.html';
            return;
        }
    }
}



var $kYLQ7 = parcelRequire("kYLQ7");
const $316fbdb12fc62afe$var$SURVEYS_STORAGE_KEY = "gamescom-surveys-v2";
function $316fbdb12fc62afe$var$getInitialSurveyStorage() {
    return {
        neozone: {
            area: "neozone",
            visitedBooth: null,
            whyDitintEvaluate: null,
            gamesSelection: null,
            lines: null,
            gift: null,
            service: null,
            comment: ""
        },
        openzone: {
            area: "openzone",
            graphics: null,
            gameplay: null,
            fun: null,
            challenge: null,
            ambience: null,
            comment: ""
        },
        final: {
            area: "final",
            overallExperience: null,
            motivation: null,
            favoriteWorld: null,
            comment: ""
        }
    };
}
function $316fbdb12fc62afe$export$49159b52b47abc52() {
    const raw = localStorage.getItem($316fbdb12fc62afe$var$SURVEYS_STORAGE_KEY);
    if (!raw) return $316fbdb12fc62afe$var$getInitialSurveyStorage();
    try {
        const parsed = JSON.parse(raw);
        const initial = $316fbdb12fc62afe$var$getInitialSurveyStorage();
        return {
            neozone: {
                ...initial.neozone,
                ...parsed.neozone
            },
            openzone: {
                ...initial.openzone,
                ...parsed.openzone
            },
            final: {
                ...initial.final,
                ...parsed.final
            }
        };
    } catch (error) {
        console.error("Erro ao ler surveys do localStorage:", error);
        return $316fbdb12fc62afe$var$getInitialSurveyStorage();
    }
}
function $316fbdb12fc62afe$export$1900149151de2bb9(data) {
    localStorage.setItem($316fbdb12fc62afe$var$SURVEYS_STORAGE_KEY, JSON.stringify(data));
}
function $316fbdb12fc62afe$export$85b0b3fd6b39a9f6() {
    localStorage.removeItem($316fbdb12fc62afe$var$SURVEYS_STORAGE_KEY);
}
function $316fbdb12fc62afe$export$a3c8ad30d20c6e78(area, patch) {
    const current = $316fbdb12fc62afe$export$49159b52b47abc52();
    const updated = {
        ...current,
        [area]: {
            ...current[area],
            ...patch
        }
    };
    $316fbdb12fc62afe$export$1900149151de2bb9(updated);
}



var $kYLQ7 = parcelRequire("kYLQ7");

async function $1150af16b7f0758c$export$d0d3754589523829(data) {
    try {
        await (0, $kYLQ7.api).sendNeozone(data);
        console.log("Neozone enviada com sucesso");
    } catch (error) {
        console.warn("Erro ao enviar neozone, salvando no localStorage", error);
        (0, $316fbdb12fc62afe$export$a3c8ad30d20c6e78)("neozone", data);
    }
}
async function $1150af16b7f0758c$export$183568bd0538fadb(data) {
    try {
        await (0, $kYLQ7.api).sendOpenzone(data);
        console.log("Openzone enviada com sucesso");
    } catch (error) {
        console.warn("Erro ao enviar openzone, salvando no localStorage", error);
        (0, $316fbdb12fc62afe$export$a3c8ad30d20c6e78)("openzone", data);
    }
}
async function $1150af16b7f0758c$export$fd8ae08ab264aed4(data) {
    try {
        await (0, $kYLQ7.api).sendFinal(data);
        console.log("Final enviado com sucesso");
    } catch (error) {
        console.warn("Erro ao enviar final, salvando no localStorage", error);
        (0, $316fbdb12fc62afe$export$a3c8ad30d20c6e78)("final", data);
    }
}
async function $1150af16b7f0758c$export$e273fe6485069c7b() {
    const stored = (0, $316fbdb12fc62afe$export$49159b52b47abc52)();
    if (stored.neozone.visitedBooth !== null) await (0, $kYLQ7.api).sendNeozone(stored.neozone);
    if (stored.openzone.graphics !== null) await (0, $kYLQ7.api).sendOpenzone(stored.openzone);
    if (stored.final.overallExperience !== null) await (0, $kYLQ7.api).sendFinal(stored.final);
    (0, $316fbdb12fc62afe$export$85b0b3fd6b39a9f6)();
}


function $fb94df661211ebc4$var$getCheckedValue(container) {
    const checked = container.querySelector('input[type="checkbox"]:checked');
    return checked?.value || null;
}
const $fb94df661211ebc4$export$ac1de63b73650ce1 = {
    getRatingValueByInputId (inputId) {
        const input = document.getElementById(inputId);
        return Number(input?.value || 1);
    },
    saveNeoZoneBranch (selectedBranch) {
        const branchMap = {
            a: "yes",
            b: "no"
        };
        (0, $316fbdb12fc62afe$export$a3c8ad30d20c6e78)("neozone", {
            visitedBooth: selectedBranch ? branchMap[selectedBranch] : null
        });
    },
    async saveNeoZoneRatings () {
        const storedBranch = $fb94df661211ebc4$var$selectedBranchFromStorage();
        const data = {
            area: "neozone",
            visitedBooth: storedBranch,
            whyDitintEvaluate: document.getElementById("whyDitintEvaluate")?.value.trim() || null,
            gamesSelection: this.getRatingValueByInputId("gamesSelection"),
            lines: this.getRatingValueByInputId("lines"),
            gift: this.getRatingValueByInputId("gift"),
            service: this.getRatingValueByInputId("service"),
            comment: document.getElementById("surveyNvidiaOptional")?.value.trim() || ""
        };
        await (0, $1150af16b7f0758c$export$d0d3754589523829)(data);
    },
    async saveOpenZoneRatings () {
        const data = {
            area: "openzone",
            graphics: this.getRatingValueByInputId("graphics"),
            gameplay: this.getRatingValueByInputId("gameplay"),
            fun: this.getRatingValueByInputId("fun"),
            challenge: this.getRatingValueByInputId("challenge"),
            ambience: this.getRatingValueByInputId("ambience"),
            comment: document.getElementById("surveyInvincibleOptional")?.value.trim() || ""
        };
        await (0, $1150af16b7f0758c$export$183568bd0538fadb)(data);
    },
    async saveFinalSurvey () {
        const wrappers = document.querySelectorAll("#experienceSurvey .options-container");
        const motivationWrapper = wrappers[1];
        const worldWrapper = wrappers[2];
        const motivationValue = $fb94df661211ebc4$var$getCheckedValue(motivationWrapper);
        const worldValue = $fb94df661211ebc4$var$getCheckedValue(worldWrapper);
        const data = {
            area: "final",
            overallExperience: this.getRatingValueByInputId("overallExperience"),
            motivation: motivationValue,
            favoriteWorld: worldValue,
            comment: document.getElementById("surveyFinalOptional")?.value.trim() || ""
        };
        await (0, $1150af16b7f0758c$export$fd8ae08ab264aed4)(data);
    },
    setupFinalSurveyCheckboxes () {
        const groups = document.querySelectorAll("#experienceSurvey .options-container");
        groups.forEach((group)=>{
            const checkboxes = group.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach((checkbox)=>{
                checkbox.addEventListener("change", ()=>{
                    if (!checkbox.checked) return;
                    checkboxes.forEach((other)=>{
                        if (other !== checkbox) other.checked = false;
                    });
                });
            });
        });
    }
};
function $fb94df661211ebc4$var$selectedBranchFromStorage() {
    try {
        const raw = localStorage.getItem("gamescom-surveys-v2");
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        return parsed?.neozone?.visitedBooth ?? null;
    } catch  {
        return null;
    }
}




var $kYLQ7 = parcelRequire("kYLQ7");

function $5b663faba757953c$var$setFinalCodeText(code) {
    const finalCodePreviewEl = document.getElementById('finalCode');
    const finalCodeStepEl = document.getElementById('code');
    const finalText = code || "C\xd3DIGO N\xc3O DISPON\xcdVEL";
    if (finalCodePreviewEl) finalCodePreviewEl.textContent = finalText;
    if (finalCodeStepEl) finalCodeStepEl.textContent = finalText;
}
function $5b663faba757953c$export$8541ee72e4a2161d(flow) {
    const existingCode = localStorage.getItem('currentCode');
    if (existingCode) {
        $5b663faba757953c$var$setFinalCodeText(existingCode);
        flow.showStep(1);
    } else flow.showStep(0);
}
function $5b663faba757953c$var$showFinalFallback(flow, hasError) {
    const finalModalContainer = document.querySelector('.modal-container.final');
    const errorDiv = document.querySelector('.error-div');
    const retryButton = document.getElementById('retrySendButton');
    finalModalContainer?.classList.add('hidden');
    if (hasError) {
        errorDiv?.classList.remove('hidden');
        if (retryButton) retryButton.disabled = false;
    } else {
        errorDiv?.classList.add('hidden');
        if (retryButton) retryButton.disabled = true;
    }
    flow.showStep(1);
}
async function $5b663faba757953c$var$submitFinalFlow() {
    await (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveFinalSurvey();
    await (0, $1150af16b7f0758c$export$e273fe6485069c7b)();
    let code = localStorage.getItem('currentCode');
    if (!code) {
        const result = await (0, $kYLQ7.api).generateCode();
        code = result.code || '';
        if (code) localStorage.setItem('currentCode', code);
    }
    return code || '';
}
async function $5b663faba757953c$var$tryFinalFlowWithRetries(maxAttempts = 3) {
    let lastError = null;
    for(let attempt = 1; attempt <= maxAttempts; attempt++)try {
        const code = await $5b663faba757953c$var$submitFinalFlow();
        return {
            success: true,
            code: code
        };
    } catch (error) {
        lastError = error;
        console.error(`Tentativa ${attempt} falhou ao enviar ratings/c\xf3digo`, error);
    }
    return {
        success: false,
        code: '',
        error: lastError
    };
}
async function $5b663faba757953c$export$d216ddfecfc75b79(flow) {
    const finalCorrectBtn = document.getElementById('correct');
    if (!finalCorrectBtn) return;
    try {
        finalCorrectBtn.disabled = true;
        finalCorrectBtn.textContent = 'ENVIANDO...';
        finalCorrectBtn.classList.add('loading');
        const result = await $5b663faba757953c$var$tryFinalFlowWithRetries(3);
        if (result.success) {
            $5b663faba757953c$var$setFinalCodeText(result.code);
            $5b663faba757953c$var$showFinalFallback(flow, false);
            return;
        }
        const existingCode = localStorage.getItem('currentCode') || '';
        $5b663faba757953c$var$setFinalCodeText(existingCode);
        $5b663faba757953c$var$showFinalFallback(flow, true);
    } catch (error) {
        console.error('Erro inesperado no fluxo final:', error);
        const existingCode = localStorage.getItem('currentCode') || '';
        $5b663faba757953c$var$setFinalCodeText(existingCode);
        $5b663faba757953c$var$showFinalFallback(flow, true);
    } finally{
        finalCorrectBtn.disabled = false;
        finalCorrectBtn.textContent = 'OK';
        finalCorrectBtn.classList.remove('loading');
    }
}
async function $5b663faba757953c$export$7cbe5632d7dd4433(flow) {
    const retryButton = document.getElementById('retrySendButton');
    const errorDiv = document.querySelector('.error-div');
    const finalErrorMessage = document.getElementById('final_error_message');
    if (!retryButton) return;
    if (!navigator.onLine) {
        alert("Voc\xea ainda est\xe1 sem internet.");
        return;
    }
    try {
        retryButton.disabled = true;
        retryButton.textContent = 'TENTANDO...';
        const code = await $5b663faba757953c$var$submitFinalFlow();
        $5b663faba757953c$var$setFinalCodeText(code);
        errorDiv?.classList.add('hidden');
        $5b663faba757953c$var$showFinalFallback(flow, false);
    } catch (error) {
        console.error('Falha na tentativa manual:', error);
        errorDiv?.classList.remove('hidden');
        finalErrorMessage.textContent = error instanceof Error ? error.message : 'Ocorreu um erro inesperado. Por favor, tente novamente.';
        retryButton.disabled = false;
        retryButton.textContent = "TENTAR POR CONTA PR\xd3PRIA";
    }
}





var $kYLQ7 = parcelRequire("kYLQ7");
async function $61f215cc46151e75$export$7595d24f3125227(payload) {
    const errorEl = document.getElementById('form-error');
    try {
        if (errorEl) errorEl.textContent = "";
        console.log('tentando registrar');
        const register = await (0, $kYLQ7.api).register(payload);
        console.log('register response:');
        if (errorEl && register.error) errorEl.textContent = register.error?.message;
        if (register.jwt) {
            console.log('registro novo funcionou');
            localStorage.setItem('jwt', register.jwt);
            return true;
        }
        // console.log('payload.email', payload.email);
        // console.log('payload.password', payload.password);
        if (register.error?.message === 'Email or Username are already taken') {
            console.log("usu\xe1rio j\xe1 existe, tentando login");
            const login = await (0, $kYLQ7.api).login({
                identifier: payload.email,
                password: payload.password
            });
            console.log('login response:', login);
            if (login.jwt) {
                console.log('login funcionou');
                localStorage.setItem('jwt', login.jwt);
                const myCodes = await (0, $kYLQ7.api).getMyCodes();
                console.log('myCodes:', myCodes);
                if (myCodes.length > 0) {
                    const sortedCodes = [
                        ...myCodes
                    ].sort((a, b)=>new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());
                    const latestCode = sortedCodes[0];
                    const lastCodeDate = new Date(latestCode.createdAt);
                    const today = new Date();
                    const hasCodeToday = lastCodeDate.getDate() === today.getDate() && lastCodeDate.getMonth() === today.getMonth() && lastCodeDate.getFullYear() === today.getFullYear();
                    console.log('latestCode:', latestCode);
                    console.log('hasCodeToday:', hasCodeToday);
                    if (hasCodeToday) {
                        localStorage.setItem('currentCode', latestCode.code);
                        console.log('indo para final.html');
                        window.location.href = './final.html';
                        return false;
                    } else localStorage.removeItem('currentCode');
                } else localStorage.removeItem('currentCode');
                return true;
            }
            console.log("login n\xe3o retornou jwt");
        }
        return false;
    } catch (error) {
        console.error('registerOrLogin caiu no catch:', error);
        if (error.message == "Invalid identifier or password") {
            if (errorEl) errorEl.textContent = "Email ou CPF/Passaporte incorretos. Verifique seus dados e tente novamente.";
        } else if (errorEl) errorEl.textContent = error instanceof Error ? error.message : 'Ocorreu um erro inesperado. Tente novamente.';
        return false;
    }
}
async function $61f215cc46151e75$export$622aad8cbe1ba3e(index) {
    if (index !== 2) return true;
    const errorEl = document.getElementById('form-error');
    if (errorEl) {
        errorEl.classList.add('hidden');
        errorEl.textContent = '';
    }
    const values = {
        name: document.getElementById('name')?.value.trim() || '',
        email: document.getElementById('email')?.value.trim() || '',
        terms: document.getElementById('terms')?.checked || false,
        birthday: document.getElementById('birthdate')?.value.trim() || '',
        gender: document.getElementById('gender')?.value.trim() || '',
        cpf: document.getElementById('cpf')?.value.trim() || ''
    };
    const rules = [
        {
            message: 'Informe seu nome.',
            valid: ()=>!!values.name
        },
        {
            message: "Selecione um g\xeanero.",
            valid: ()=>!!values.gender
        },
        {
            message: 'Informe sua data de nascimento.',
            valid: ()=>!!values.birthday
        },
        {
            message: 'Informe CPF ou passaporte.',
            valid: ()=>!!values.cpf
        },
        {
            message: "Informe um e-mail v\xe1lido.",
            valid: ()=>/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)
        },
        {
            message: "Voc\xea precisa aceitar os termos.",
            valid: ()=>values.terms === true
        }
    ];
    for (const rule of rules)if (!rule.valid()) {
        if (errorEl) {
            errorEl.textContent = rule.message;
            errorEl.classList.remove('hidden');
        }
        return false;
    }
    const payload = {
        username: values.email,
        name: values.name,
        email: values.email,
        password: values.cpf,
        gender: values.gender,
        birthday: values.birthday,
        cpf: values.cpf,
        terms: values.terms
    };
    try {
        const success = await $61f215cc46151e75$export$7595d24f3125227(payload);
        if (!success && errorEl) errorEl.classList.remove('hidden');
        return success;
    } catch (error) {
        console.error("Erro ao validar formul\xe1rio de introdu\xe7\xe3o:", error);
        if (errorEl) {
            errorEl.textContent = 'Ocorreu um erro ao enviar seus dados. Tente novamente.';
            errorEl.classList.remove('hidden');
        }
        return false;
    }
}


function $f569d071631ffc82$export$cb547aa49d20d71d(page) {
    const codes = {
        shadowzone: [
            'misterio',
            'solidao',
            'entidade',
            'profundeza'
        ],
        neozone: [
            'cibernetica',
            'utopia',
            'futuro',
            'futuro'
        ],
        openzone: [
            'realidade',
            'infinito',
            'potencial',
            'galaxia'
        ],
        herozone: [
            'heroismo',
            'coragem',
            'justica',
            'honra'
        ]
    };
    return codes[page] || [];
}
function $f569d071631ffc82$var$getDailyIndex(length) {
    const baseDate = new Date(2026, 3, 30);
    const today = new Date();
    baseDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffInMs = today.getTime() - baseDate.getTime();
    const diffInDays = Math.floor(diffInMs / 86400000);
    return (diffInDays % length + length) % length;
}
function $f569d071631ffc82$export$af3fd613c1f09374(page) {
    const codes = $f569d071631ffc82$export$cb547aa49d20d71d(page);
    if (!codes.length) return '';
    return codes[$f569d071631ffc82$var$getDailyIndex(codes.length)];
}
function $f569d071631ffc82$var$normalizeText(value) {
    return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().trim();
}
function $f569d071631ffc82$export$2894a166266cb4f3(index, page) {
    if (index !== 0) return true;
    const textarea = document.getElementById('neoZoneCode');
    textarea?.addEventListener('input', ()=>{
        const cursor = textarea.selectionStart || 0;
        textarea.value = $f569d071631ffc82$var$normalizeText(textarea.value);
        textarea.setSelectionRange(cursor, cursor);
    });
    const input = $f569d071631ffc82$var$normalizeText(textarea?.value || '');
    const container = document.querySelector('.modal-container');
    const correctDiv = document.getElementById('correctCodeDiv');
    const incorrectDiv = document.getElementById('incorrectCodeDiv');
    correctDiv?.classList.add('hidden');
    incorrectDiv?.classList.add('hidden');
    if (!input) return false;
    container?.classList.remove('hidden');
    const correctCode = $f569d071631ffc82$var$normalizeText($f569d071631ffc82$export$af3fd613c1f09374(page));
    if (input === correctCode) correctDiv?.classList.remove('hidden');
    else incorrectDiv?.classList.remove('hidden');
    return false;
}




function $25d073681950e2d7$export$d2cec5f9e7d13595(flow, afterBranchStep, onBranchChange) {
    const optionA = document.getElementById('option-a');
    const optionB = document.getElementById('option-b');
    const questionContinue = document.getElementById('question-continue');
    const optionABlock = document.querySelector('.option-a-checked');
    const optionBBlock = document.querySelector('.option-b-checked');
    let selectedBranch = null;
    if (!optionA || !optionB || !questionContinue) return;
    optionA.checked = false;
    optionB.checked = false;
    optionA.addEventListener('change', ()=>{
        if (optionA.checked) {
            selectedBranch = 'a';
            optionB.checked = false;
        } else if (optionB.checked) selectedBranch = 'b';
        else selectedBranch = null;
        onBranchChange?.(selectedBranch);
    });
    optionB.addEventListener('change', ()=>{
        if (optionB.checked) {
            selectedBranch = 'b';
            optionA.checked = false;
        } else if (optionA.checked) selectedBranch = 'a';
        else selectedBranch = null;
        onBranchChange?.(selectedBranch);
    });
    questionContinue.addEventListener('click', (event)=>{
        event.preventDefault();
        if (!selectedBranch) return;
        optionABlock?.classList.add('hidden');
        optionBBlock?.classList.add('hidden');
        if (selectedBranch === 'a') optionABlock?.classList.remove('hidden');
        if (selectedBranch === 'b') optionBBlock?.classList.remove('hidden');
        flow.showStep(afterBranchStep);
    });
}


function $17793e4ae107ef7c$export$85a322aa4c1d7bec() {
    const nameInput = document.getElementById('name');
    const birthInput = document.getElementById('birthdate');
    const cpfInput = document.getElementById('cpf');
    nameInput?.addEventListener('input', ()=>{
        nameInput.value = nameInput.value.replace(/[^a-zA-ZÀ-ÿ\s]/g, '');
    });
    birthInput?.addEventListener('input', ()=>{
        let value = birthInput.value.replace(/\D/g, '');
        if (value.length > 8) value = value.slice(0, 8);
        if (value.length > 4) value = value.replace(/(\d{2})(\d{2})(\d{0,4})/, '$1/$2/$3');
        else if (value.length > 2) value = value.replace(/(\d{2})(\d{0,2})/, '$1/$2');
        birthInput.value = value;
    });
    cpfInput?.addEventListener('input', ()=>{
        let rawValue = cpfInput.value;
        let value = rawValue.replace(/[^a-zA-Z0-9]/g, '');
        const hasLetters = /[a-zA-Z]/.test(value);
        if (!hasLetters) {
            value = value.slice(0, 11);
            if (value.length > 9) value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{0,2})/, '$1.$2.$3-$4');
            else if (value.length > 6) value = value.replace(/(\d{3})(\d{3})(\d{0,3})/, '$1.$2.$3');
            else if (value.length > 3) value = value.replace(/(\d{3})(\d{0,3})/, '$1.$2');
        } else value = value.slice(0, 20);
        cpfInput.value = value;
    });
}



var $8CkzA = parcelRequire("8CkzA");



// =====================
// STATE
// =====================
const $be37e3b71aa0f507$var$page = document.body.dataset.page || '';
let $be37e3b71aa0f507$var$selectedBranch = null;
// =====================
// HELPERS
// =====================
function $be37e3b71aa0f507$var$setStoredCodeOnScreen(code) {
    const codeEl = document.getElementById('code');
    const finalCodeEl = document.getElementById('finalCode');
    if (codeEl) codeEl.textContent = code.toUpperCase();
    if (finalCodeEl) finalCodeEl.textContent = code.toUpperCase();
}
function $be37e3b71aa0f507$var$restoreFinalScreenIfCodeAlreadyExists(flow) {
    if ($be37e3b71aa0f507$var$page !== 'final') return;
    const existingCode = localStorage.getItem('currentCode');
    if (!existingCode) return;
    $be37e3b71aa0f507$var$setStoredCodeOnScreen(existingCode);
    flow.showStep(1);
}
function $be37e3b71aa0f507$var$setupRatings() {
    const bars = document.querySelectorAll('.rating-bar');
    const thumbPositions = {
        '1': '10%',
        '2': '30%',
        '3': '50%',
        '4': '70%',
        '5': '90%'
    };
    const fillPositions = {
        '1': '10%',
        '2': '30%',
        '3': '50%',
        '4': '70%',
        '5': '100%'
    };
    bars.forEach((bar)=>{
        const hiddenInput = bar.querySelector('input[type="hidden"]');
        const steps = bar.querySelectorAll('.rating-step');
        const thumb = bar.querySelector('.rating-thumb');
        const setValue = (value)=>{
            bar.dataset.rating = value;
            bar.style.setProperty('--thumb-left', thumbPositions[value]);
            bar.style.setProperty('--fill', fillPositions[value]);
            if (hiddenInput) hiddenInput.value = value;
            const current = Number(value);
            steps.forEach((step)=>{
                const stepValue = Number(step.dataset.value);
                step.classList.remove('active', 'passed');
                if (stepValue === current) step.classList.add('active');
                else if (stepValue < current) step.classList.add('passed');
            });
            if (thumb) thumb.style.left = thumbPositions[value];
        };
        setValue(bar.dataset.rating || '1');
        steps.forEach((step)=>{
            step.addEventListener('click', ()=>{
                setValue(step.dataset.value || '1');
            });
        });
    });
}
// =====================
// INIT
// =====================
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $5f2b8dee7d819d4f$export$dea75f1d0fc0729c)($be37e3b71aa0f507$var$page);
    const versionEl = document.getElementById('version');
    if (versionEl) versionEl.innerHTML = 'v1.5.03.1';
    const config = (0, $f0401da5f96e7704$export$1cc5c63550d76ed8)($be37e3b71aa0f507$var$page);
    const flow = new (0, $24dc23990372eceb$export$84cb684d9bf21001)({
        stepSelector: config.stepSelector,
        validateStep: (index)=>{
            if ($be37e3b71aa0f507$var$page === 'intro') return (0, $61f215cc46151e75$export$622aad8cbe1ba3e)(index);
            return (0, $f569d071631ffc82$export$2894a166266cb4f3)(index, $be37e3b71aa0f507$var$page);
        },
        onFinish: ()=>{
            if ($be37e3b71aa0f507$var$page === 'intro') localStorage.setItem('intro-completed', 'true');
            if (!(0, $5f2b8dee7d819d4f$export$6c2447a395f7715f)($be37e3b71aa0f507$var$page) && $be37e3b71aa0f507$var$page !== 'intro') {
                console.log("Voc\xea precisa concluir esta zona antes de avan\xe7ar.");
                return;
            }
            if (config.nextUrl) window.location.href = config.nextUrl;
        }
    });
    flow.init();
    (0, $17793e4ae107ef7c$export$85a322aa4c1d7bec)();
    $be37e3b71aa0f507$var$setupRatings();
    $be37e3b71aa0f507$var$restoreFinalScreenIfCodeAlreadyExists(flow);
    // =====================
    // INTRO FLOW
    // =====================
    const introPage = document.getElementById('intro');
    const introContinueBtn = document.querySelector('#intro [data-action="next"]');
    introContinueBtn?.addEventListener('click', (event)=>{
        event.preventDefault();
        introPage?.classList.add('hidden');
        introPage?.classList.remove('active');
        window.scrollTo(0, 0);
        flow.showStep(1);
    });
    // =====================
    // MODAL CODE FLOW
    // =====================
    const correctBtn = document.getElementById('correct');
    const incorrectBtn = document.getElementById('incorrect');
    const modalContainer = document.querySelector('.modal-container');
    const correctDiv = document.getElementById('correctCodeDiv');
    const incorrectDiv = document.getElementById('incorrectCodeDiv');
    if ($be37e3b71aa0f507$var$page !== 'final') {
        correctBtn?.addEventListener('click', ()=>{
            modalContainer?.classList.add('hidden');
            correctDiv?.classList.add('hidden');
            (0, $5f2b8dee7d819d4f$export$5a6c525e6f8d1540)($be37e3b71aa0f507$var$page);
            window.scrollTo(0, 0);
            if (typeof config.afterCodeStep === 'number') flow.showStep(config.afterCodeStep);
        });
        incorrectBtn?.addEventListener('click', ()=>{
            modalContainer?.classList.add('hidden');
            incorrectDiv?.classList.add('hidden');
        });
    }
    // =====================
    // FINAL FLOW
    // =====================
    if ($be37e3b71aa0f507$var$page === 'final') {
        const finalContinueBtn = document.getElementById('finalContinue');
        const finalModalContainer = document.querySelector('.modal-container.final');
        const finalCorrectBtn = document.getElementById('correct');
        const retrySendButton = document.getElementById('retrySendButton');
        (0, $fb94df661211ebc4$export$ac1de63b73650ce1).setupFinalSurveyCheckboxes();
        finalContinueBtn?.addEventListener('click', async (event)=>{
            event.preventDefault();
            await (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveFinalSurvey();
            finalModalContainer?.classList.remove('hidden');
        });
        finalCorrectBtn?.addEventListener('click', async ()=>{
            await (0, $5b663faba757953c$export$d216ddfecfc75b79)(flow);
        });
        retrySendButton?.addEventListener('click', async ()=>{
            await (0, $5b663faba757953c$export$7cbe5632d7dd4433)(flow);
        });
    }
    // =====================
    // BRANCH FLOW (NEO / OPEN)
    // =====================
    if (config.hasBranchQuestion && typeof config.afterBranchStep === 'number') (0, $25d073681950e2d7$export$d2cec5f9e7d13595)(flow, config.afterBranchStep, (branch)=>{
        $be37e3b71aa0f507$var$selectedBranch = branch;
    });
    // =====================
    // SHORT FLOW (SHADOW / HERO)
    // =====================
    if (config.isShortFlow) {
        const buttons = document.querySelectorAll('#question [data-action="next"]');
        buttons.forEach((btn)=>{
            btn.addEventListener('click', (event)=>{
                event.preventDefault();
                window.scrollTo(0, 0);
                flow.showStep(2);
            });
        });
    }
    // =====================
    // SAVE SURVEY
    // ======================
    if ($be37e3b71aa0f507$var$page === 'neozone') {
        const questionContinueBtn = document.getElementById('question-continue');
        const confirmNeoZoneSurveyBtn = document.getElementById('confirmNeoZoneSurvey');
        const skipNvidiaEvaluationBtn = document.getElementById('skipNvidiaEvaluation');
        const optionAInput = document.getElementById('option-a');
        const optionBInput = document.getElementById('option-b');
        const optionACheckedDiv = document.querySelector('.option-a-checked');
        const optionBCheckedDiv = document.querySelector('.option-b-checked');
        const evaluateFromOptionBBtn = document.querySelector('.option-b-checked .button.bigger.neozone');
        function showOptionAContent() {
            optionACheckedDiv?.classList.remove('hidden');
            optionBCheckedDiv?.classList.add('hidden');
        }
        function showOptionBContent() {
            optionBCheckedDiv?.classList.remove('hidden');
            optionACheckedDiv?.classList.add('hidden');
        }
        questionContinueBtn?.addEventListener('click', ()=>{
            if (optionAInput?.checked) {
                $be37e3b71aa0f507$var$selectedBranch = 'a';
                (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveNeoZoneBranch('a');
                showOptionAContent();
                return;
            }
            if (optionBInput?.checked) {
                $be37e3b71aa0f507$var$selectedBranch = 'b';
                (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveNeoZoneBranch('b');
                showOptionBContent();
                return;
            }
        });
        skipNvidiaEvaluationBtn?.addEventListener('click', async (event)=>{
            event.preventDefault();
            const textarea = document.getElementById('whyDitintEvaluate');
            const errorSpan = document.querySelector('.option-b-checked .error-span');
            const value = textarea?.value.trim() || '';
            if (!value) {
                errorSpan?.classList.remove('hidden');
                errorSpan?.classList.add('show');
                return;
            }
            errorSpan?.classList.add('hidden');
            errorSpan?.classList.remove('show');
            (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveNeoZoneBranch('b');
            await (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveNeoZoneRatings();
            window.scrollTo(0, 0);
            flow.showStep(4); // vai direto para zoneIntro
        });
        evaluateFromOptionBBtn?.addEventListener('click', (event)=>{
            event.preventDefault();
            showOptionAContent();
            flow.showStep(3); // vai para question-3
        });
        confirmNeoZoneSurveyBtn?.addEventListener('click', async ()=>{
            (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveNeoZoneBranch('a');
            await (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveNeoZoneRatings();
        });
    }
    if ($be37e3b71aa0f507$var$page === 'openzone') {
        const confirmOpenZoneSurveyBtn = document.getElementById('confirmOpenZoneSurvey');
        confirmOpenZoneSurveyBtn?.addEventListener('click', async ()=>{
            await (0, $fb94df661211ebc4$export$ac1de63b73650ce1).saveOpenZoneRatings();
        });
    }
    console.log("P\xe1gina:", $be37e3b71aa0f507$var$page, "| Pr\xf3xima:", config.nextUrl);
});


//# sourceMappingURL=gamescom-app.9eea4081.js.map
